/* eslint-disable no-unused-vars */
import React, { memo, useState } from 'react'
import Box from '@mui/material/Box'

import OnedayHeader from 'components/layout/OnedayHeader/OnedayHeader'
import OnedayMain from 'components/OneDayPage/OnedayMain'
import OneDayFeatures from 'components/OneDayPage/OneDayFeatures'
import HowItWorks from 'components/OneDayPage/HowItWorks'
import OnedaySuccessLead from 'components/OneDayPage/OnedaySuccessLead'
import OnedayFooter from 'components/layout/OnedayFooter'

import sx from './styles'

const OneDay = (props) => {
  const [isSuccess, setIsSuccess] = useState(false)
  const [appointmentData, setAppointmentData] = useState(null)

  const handleSuccess = (data) => {
    setAppointmentData(data)
    setIsSuccess(true)
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  return (
    <Box sx={sx.root}>
      <OnedayHeader />

      {/* Condicional: Si es exitoso, muestra la tarjeta, si no, la landing normal */}
      {isSuccess ? (
        <OnedaySuccessLead
          name={appointmentData?.name}
          carModel={`${appointmentData?.make} ${appointmentData?.model} ${appointmentData?.year}`}
          date={appointmentData?.date}
          time={appointmentData?.time}
        />
      ) : (
        <>
          <OnedayMain onSuccess={handleSuccess} />
          {' '}
          <OneDayFeatures />
          <HowItWorks />
        </>
      )}

      <OnedayFooter />
    </Box>
  )
}

export default memo(OneDay)
